import SettingsApi from '@/api/settings'
import { CURRENCIES, currencySymbol, formatCurrency } from '@/helpers/currency'

const DEFAULTS = {
  currency_code: 'USD',
  timezone: 'UTC',
  plan: 'free'
}

export default {
  namespaced: true,
  state: () => ({
    currencyCode: DEFAULTS.currency_code,
    timezone: DEFAULTS.timezone,
    plan: DEFAULTS.plan,
    lastLoadedAt: null
  }),
  getters: {
    currencyCode: (s) => s.currencyCode,
    currencySymbol: (s) => currencySymbol(s.currencyCode),
    currencyFormatter:
      (s) =>
      (amount, opts = {}) =>
        formatCurrency(amount, s.currencyCode, opts),
    timezone: (s) => s.timezone,
    plan: (s) => s.plan,
    currencies: () => CURRENCIES
  },
  mutations: {
    SET_SETTINGS(state, payload) {
      state.currencyCode = payload.currency_code || DEFAULTS.currency_code
      state.timezone = payload.timezone || DEFAULTS.timezone
      state.plan = payload.plan || DEFAULTS.plan
      state.lastLoadedAt = Date.now()
    }
  },
  actions: {
    async fetchSettings({ commit }) {
      try {
        const data = await SettingsApi.fetchOrgSettings()
        if (data) commit('SET_SETTINGS', data)
      } catch (e) {
        // If not created yet or unauthorized, ignore; UI will use defaults
        console.warn(
          'Settings fetch failed (using defaults until saved):',
          e?.message || e
        )
      }
    },
    async saveSettings({ commit }, payload) {
      const toSave = {
        currency_code: payload.currency_code,
        timezone: payload.timezone,
        plan: payload.plan
      }
      const saved = await SettingsApi.saveOrgSettings(toSave)
      commit('SET_SETTINGS', saved)
      return saved
    }
  }
}
